import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('BEST_TAGS_ARTICLE').plugin(axiosPlugin, {template: "array"});

let fetchBestTagsArticleAction = redux.fetchActionGet();

export const fetchBestTagsArticle = (query = {}) => fetchBestTagsArticleAction(`/cachetags?${queryString.stringify(query)}`);

export const resetBestTagsArticle = () => redux.actions.reset();

export const bestTagArticle = redux.reducer();